import { render, staticRenderFns } from "./SurvivalCard.vue?vue&type=template&id=0b8f4d31"
import script from "./SurvivalCard.vue?vue&type=script&lang=js"
export * from "./SurvivalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports